import Debug from 'debug';
import { PracticeStateMachineAbstractState, PracticeStateMachineCommonEvents } from './state'
import { PracticeStateMachineData } from '../data'

const debug = Debug('practice-canceled-state')

export class PracticeCanceledState extends PracticeStateMachineAbstractState<PracticeStateMachineCommonEvents> {

  public readonly name = 'canceled'

  constructor() {
    super()
  }

  enter() {
    debug('enter')
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    // NOP
  }
}
